/** Serializa filtros do Fluxo para queryKey estável (React Query). */
export const serializarFiltrosFluxo = (filters) =>
  JSON.stringify({
    filas: (filters.queues || []).map((q) => q.id),
    situacoes: (filters.situacoes || []).map((s) => s.id),
    usuarios: (filters.users || []).map((u) => u.id),
    contatos: filters.contatos || [],
    lidas: filters.lidas,
  })
